module.exports = __webpack_public_path__ + "static/media/Icona-5.d843be97.svg";